import PropTypes from 'prop-types';
import { contentType } from '~/types/content';
import { creatorType } from '~/types/creator';
import { creatorBrandType } from '~/types/creator-brand';

export const campaignReportType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  creator: creatorType,
  contents: PropTypes.arrayOf(contentType),
  creatorBrand: creatorBrandType,
  priceAmount: PropTypes.number,
  priceCurrency: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  igContentAssets: PropTypes.shape({
    image: PropTypes.shape({
      count: PropTypes.number,
    }),
    video: PropTypes.shape({
      count: PropTypes.number,
    }),
    album: PropTypes.shape({
      count: PropTypes.number,
    }),
    story: PropTypes.shape({
      count: PropTypes.number,
    }),
  }),
  imageInsights: PropTypes.shape({
    totalEngagement: PropTypes.number,
    averageFollowerEngagementRate: PropTypes.number,
    averageReachEngagementRate: PropTypes.number,
  }),
  videoInsights: PropTypes.shape({
    totalEngagement: PropTypes.number,
    averageFollowerEngagementRate: PropTypes.number,
    averageReachEngagementRate: PropTypes.number,
    totalVideoViews: PropTypes.number,
  }),
  albumInsights: PropTypes.shape({
    totalEngagement: PropTypes.number,
    averageFollowerEngagementRate: PropTypes.number,
    averageReachEngagementRate: PropTypes.number,
  }),
  storyInsights: PropTypes.shape({
    igTotalReach: PropTypes.number,
    igTotalImpressions: PropTypes.number,
    igTotalSwipeUps: PropTypes.number,
  }),
  visibility: PropTypes.object,
  igAvgFeedEngagements: PropTypes.number,
  igAvgFeedImpressions: PropTypes.number,
  igAvgFeedReach: PropTypes.number,
  igAvgStoryImpressions: PropTypes.number,
  igAvgStoryReach: PropTypes.number,
  igCpe: PropTypes.number,
  igCpm: PropTypes.number,
  createdAtAgo: PropTypes.string,
  igAvgFeedFollowerEngRate: PropTypes.number,
  igAvgFeedReachEngRate: PropTypes.number,
  igTotalSwipeUps: PropTypes.number,
});
